module.exports = __webpack_public_path__ + "img/catF.17142a3b.svg";